import { getSingleton, setSingleton } from "./firestoreHelpers";

const COLL = "alquileres_config";
const DOC_ID = "main";

const DEFAULTS = {
  comisionPorcentaje: 5,
  diasAlertaVencimiento: 30,
  // Firma para los recibos: imagen como data URL (base64) + aclaración.
  firmaImg: "",
  firmaAclaracion: "Agustín Plorutti",
  // Datos de la inmobiliaria que se imprimen en el recibo.
  reciboDomicilio: "",
  reciboLocalidad: "",
  reciboCuit: "",
};

export const getConfigAlquileres = async () => getSingleton(COLL, DOC_ID, DEFAULTS);

export const saveConfigAlquileres = async (data) => setSingleton(COLL, DOC_ID, data);
